<template>
  <div>
    <div class="save-bar-top fixed-top" v-if="bar && hasChanged">
      <div class="brand outer-brand" v-if="$mq !== 'sm'">
        <Logo height="24" alt="Superchargify Logo" />
      </div>
      <div class="main-alignment">
        <div class="container save-container">
          <div class="brand inner-brand" v-if="$mq !== 'sm'">
            <Logo height="24" alt="Superchargify Logo" />
          </div>
          <div class="save-bar text-right">
            <button v-if="discard && hasChanged" class="btn btn-link btn-discard text-muted" @click="revert">{{discardText}}</button>
            <SaveBtn :hasChanged="hasChanged" :savingText="savingText" :saveText="saveText" :savedText="savedText" @click="click" />
          </div>
        </div>
      </div>
    </div>
    <div class="mt-4" v-else>
      <SaveBtn :hasChanged="hasChanged" :savingText="savingText" :saveText="saveText" :savedText="savedText" @click="click" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SaveBtn from '@/components/SaveBtn'
import Logo from '@/components/Logo'

export default {
  components: {
    SaveBtn,
    Logo
  },
  props: {
    discard: Boolean,
    bar: Boolean,

    hasChanged: Boolean,
    savingText: String,
    saveText: String,
    savedText: String,

    discardText: {
      type: String,
      default: 'Discard changes'
    }
  },
  computed: mapState([ 'saving' ]),
  methods: {
    click: function () {
      this.$emit('click')
    },
    revert: function () {
      this.$store.commit('REVERT_CHANGES')
      this.$emit('revert')
    }
  }
}
</script>
